import {AlertBanner, ColourSolid, useLayout} from "@twigsby/frontend-framework";
import {useEffect} from "react";
import {useUKPBAuth} from "../../Providers/AuthProvider";

const UserAccountAlert = () => {
    const { token } = useUKPBAuth();

    if(!token) return <></>;

    return (
        <AccountAlertContent />
    )
}

const AccountAlertContent = () => {
    const isWrong = true;
    const { setDefaultLayout, setSidebarHeaderLayout } = useLayout();

    useEffect(() => {
        if(isWrong) {
            setSidebarHeaderLayout();
        } else {
            setDefaultLayout();
        }
    }, []);

    return (
        <AlertBanner title={'Your User is overdue, your User will be closed if you don\'t renew.'} colourMod={ColourSolid.Alert} />
    )
}

export { UserAccountAlert }
